module.exports = __webpack_public_path__ + "63bec59c.svg";